import { axiosDS } from '@pp/axios'
import { SimpleResponse } from 'Types/simpleResponse'
import { ResponseCatalog, RequestParams } from 'Models'
import { urls } from 'Constants/Urls'
import { DadataSuggestByIdPartyModel, DadataSuggestByIdPartyCreateModel } from 'Pages/admin'

export const dadataFakeResponsesApi = {
	getAll: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<DadataSuggestByIdPartyModel>>(
			urls.fake_responses.dadata_suggest_by_id_party,
			{ params }
		)
		return res.data
	},
	getOne: async (id: number) => {
		const res = await axiosDS().get<DadataSuggestByIdPartyModel>(
			`${urls.fake_responses.dadata_suggest_by_id_party}/${id}`
		)
		return res.data
	},
	createOne: async (data: DadataSuggestByIdPartyCreateModel) => {
		const res = await axiosDS().post<DadataSuggestByIdPartyModel>(
			urls.fake_responses.dadata_suggest_by_id_party,
			{ data }
		)
		return res.data
	},
	updateOne: async (data: DadataSuggestByIdPartyModel) => {
		const res = await axiosDS().patch<ResponseCatalog<DadataSuggestByIdPartyModel>>(
			`${urls.fake_responses.dadata_suggest_by_id_party}/${data.id}`,
			{ data }
		)
		return res.data
	},
	deleteOne: async (id: number) => {
		const res = await axiosDS().delete<SimpleResponse>(
			`${urls.fake_responses.dadata_suggest_by_id_party}/${id}`
		)
		return res.data
	},
}
